module.exports = __webpack_public_path__ + "static/media/hi.4a5763ec.svg";